/** Product display name used in user-facing copy. */
export const APP_NAME = 'Arvoke'
// The one Arvoke address; matches DEFAULT_APP_EMAIL in backend/app/config.py.
export const DEFAULT_APP_EMAIL = 'hello@arvoke.com'
// Automation email's own mailbox (AUTOMATIONS_EMAIL in backend/app/config.py):
// what it's From, and the To of one no one sees the recipients of.
export const AUTOMATIONS_EMAIL = 'automations@arvoke.com'

/** Default name for temporary views created by auto-promote */
export const DEFAULT_TEMP_VIEW_NAME = 'Untitled View'

/** Number of rows requested by each records window fetch. */
export const RECORD_WINDOW_LIMIT = 100

/** Largest page the records endpoints return (their `limit` maximum). */
export const MAX_RECORDS_PAGE_LIMIT = 1000

/**
 * Most rows a grouped read carries over when a group is expanded or collapsed:
 * it re-reads the rows already loaded, in pages of `MAX_RECORDS_PAGE_LIMIT`
 * one after another, so this bounds that read to ten requests.
 */
export const MAX_CARRIED_RECORDS_DEPTH = 10 * MAX_RECORDS_PAGE_LIMIT

/** Number of unpinned columns requested by each column-axis records window fetch. */
export const COLUMN_WINDOW_LIMIT = 100

/**
 * Horizontal data runway in columns on each side of the visible unpinned
 * column window. Tuned independently from the vertical row runway.
 * Safe zone width = COLUMN_WINDOW_LIMIT - 2 * HORIZONTAL_COLUMN_PREFETCH_BUFFER.
 */
export const HORIZONTAL_COLUMN_PREFETCH_BUFFER = 38

/** Distance between adjacent prefetched column windows. */
export const COLUMN_WINDOW_STRIDE = COLUMN_WINDOW_LIMIT - 2 * HORIZONTAL_COLUMN_PREFETCH_BUFFER

/** Cache freshness window for navigation models hydrated during app startup. */
export const NAVIGATION_QUERY_STALE_TIME_MS = 5 * 60 * 1000
